import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { CloseDrawer, OpenDrawer, SetDrawerWidth, ToggleDrawer } from '../actions/drawer.actions';
import { AlioState } from '../reducers';
import * as selectors from '../selectors/drawer.selectors';

@Injectable({
  providedIn: 'root',
})
export class DrawerFacadeService extends FacadeService {
  constructor(public override store: Store<AlioState>) {
    super(store);
  }

  isOpen$ = this.storeSelect(selectors.getDrawerIsOpen);
  width$ = this.storeSelect(selectors.getDrawerWidth);

  get isOpen(): boolean {
    return this.storeSnapshot(this.isOpen$);
  }

  open(): void {
    this.dispatch(OpenDrawer());
  }

  close(): void {
    this.dispatch(CloseDrawer());
  }

  toggle(): void {
    this.dispatch(ToggleDrawer());
  }

  setWidth(width: number): void {
    this.dispatch(SetDrawerWidth({ width: Math.min(width, window.innerWidth) }));
  }
}
